export default __webpack_public_path__ + "static/media/single.0204a239.png";